import { useState } from 'react';
export function useCopyToClipboard() {
    const [copiedText, setCopiedText] = useState(null);
    const copy = async (text) => {
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
            return false;
        }
        // Try to save to clipboard then save it in the state if worked
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        }
        catch (error) {
            console.warn('Copy failed', error);
            setCopiedText(null);
            return false;
        }
    };
    return [copiedText, copy];
}
export default useCopyToClipboard;
//# sourceMappingURL=useCopyToClipboard.js.map